import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithSocialAccountHealthProvider, useSocialAccountHealth] = createComponentHealth('CreateWedding | Social intercept');
